export const fullTitle = (honorific:string|undefined, prefix:string|undefined,title:string|undefined,suffix:string|undefined) =>{
    return (honorific ? honorific + ' ' : '') +
        (prefix ? prefix.trim() + (prefix.trim().endsWith('/') ? '' : ' ') : '') + 
        (title ? title : '') +
        (suffix ? ((suffix.trim().startsWith(',') || suffix.trim().startsWith('/')) ? '' : ' ') + suffix.trim() : '')
}
